export default __webpack_public_path__ + "static/media/badbuddies2_nft.59b6f4d8.mp4";